.dashboard-card {
  min-width: 0; padding: 14px; border: 1px solid var(--color-slate-200, #e2e8f0);
  border-radius: 4px; background: #fff; color: var(--color-slate-900, #0f172a); box-shadow: none;
}
.dashboard-card-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
.dashboard-card-header > div:first-child { min-width: 0; }
.dashboard-card-header h2 { margin: 0; font-size: 15px; font-weight: 750; line-height: 1.35; }
.dashboard-card-header p, .dashboard-card-note { margin: 4px 0 0; font-size: 11px; line-height: 1.5; color: var(--color-slate-700, #334155); }
.dashboard-card-actions { flex: 0 0 auto; }
.dashboard-card-body { margin-top: 16px; min-width: 0; }
.dashboard-card-note { margin-top: 12px; }
.dashboard-kpis { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin-bottom: 14px; }
.dashboard-kpis-three { grid-template-columns: repeat(auto-fit, minmax(min(140px, 100%), 1fr)); }
.dashboard-kpis-single { grid-template-columns: minmax(0, 1fr); }
.dashboard-stat { min-width: 0; margin: 0; }
.dashboard-stat dl { margin: 0; }
.dashboard-kpis .dashboard-stat dt { min-height: 24px; }
.dashboard-stat dt, .dashboard-meter-label { display: flex; align-items: center; gap: 5px; font-size: 11px; line-height: 1.45; color: var(--color-slate-700, #334155); }
.dashboard-stat dd { margin: 4px 0 0; font-size: 23px; line-height: 1.25; font-weight: 750; font-variant-numeric: tabular-nums; white-space: nowrap; }
.dashboard-stat-note { margin: 4px 0 0; font-size: 11px; line-height: 1.45; color: var(--color-slate-700, #334155); }
.dashboard-support { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; border-top: 1px solid var(--color-slate-200, #e2e8f0); margin-top: 14px; padding-top: 12px; }
.dashboard-support-three { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.dashboard-support .dashboard-stat dd { font-size: 17px; }
.dashboard-meters { display: grid; gap: 14px; }
.dashboard-meter { min-width: 0; }
.dashboard-meter-heading { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; }
.dashboard-meter-value { flex-shrink: 0; font-size: 15px; font-weight: 750; white-space: nowrap; font-variant-numeric: tabular-nums; }
.dashboard-meter-track { height: 7px; overflow: hidden; border-radius: 4px; background: var(--color-slate-200, #e2e8f0); margin-top: 7px; }
.dashboard-meter-fill { height: 100%; border-radius: 4px; background: var(--color-accent); }
.dashboard-meter-note { margin: 4px 0 0; font-size: 11px; line-height: 1.45; color: var(--color-slate-700, #334155); }
.dashboard-hint-button { display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; width: 24px; height: 24px; border: 1px solid var(--color-slate-300, #cbd5e1); border-radius: 4px; background: #fff; color: var(--color-slate-700, #334155); padding: 3px; cursor: pointer; }
.dashboard-hint-button:hover { background: var(--color-slate-50, #f8fafc); border-color: var(--color-slate-400, #94a3b8); }
.dashboard-hint-button:focus-visible, .dashboard-chart-target:focus-visible { outline: 2px solid var(--color-accent); outline-offset: 1px; }
.dashboard-chart-scroll { max-width: 100%; overflow-x: auto; overscroll-behavior-x: contain; }
.dashboard-chart-canvas { position: relative; width: 100%; }
.dashboard-chart-canvas svg { display: block; width: 100%; height: auto; }
.dashboard-chart-label { font-size: 11px; font-weight: 500; fill: var(--color-slate-700, #334155); }
.dashboard-chart-grid { stroke: var(--color-slate-200, #e2e8f0); stroke-width: 1; }
.dashboard-chart-bar { fill: var(--color-accent); }
.dashboard-chart-line { fill: none; stroke: var(--color-accent); stroke-width: 2.5; stroke-linejoin: round; }
.dashboard-chart-target { position: absolute; border: 1px solid transparent; border-radius: 4px; padding: 0; background: transparent; cursor: pointer; }
.dashboard-chart-target:hover { background: rgba(100, 116, 139, .04); border-color: var(--color-slate-400, #94a3b8); }
.dashboard-chart-target:focus-visible { outline-offset: -2px; }
.dashboard-chart-mobile-note { display: none; }
@media (max-width: 767px) {
  .dashboard-chart-canvas { min-width: var(--chart-touch-width, 440px); }
  .dashboard-chart-mobile-note { display: inline; }
}
@media (max-width: 600px) {
  .dashboard-card { padding: 11px; }
  .dashboard-kpis { gap: 8px; }
  .dashboard-stat dd { font-size: 18px; }
  .dashboard-stat dt { font-size: 11px; }
  .dashboard-support-three { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
.report-visual .dashboard-chart-mobile-note { display: none; }
.report-visual .dashboard-hint-button { display: none; }

/* Match the compact truck banner used by Import, Reports and Data Manager. */
[data-mobile-workspace="dashboard"] > .dashboard-hero {
  container: dashboard-hero / inline-size;
  position: relative;
  isolation: isolate;
  min-height: 72px;
  padding: 6px 20px;
  overflow: clip;
  border: 1px solid var(--color-line-soft);
  border-radius: 4px;
  background: white;
}
.dashboard-hero::before {
  position: absolute;
  z-index: -1;
  inset: 0 0 0 auto;
  width: 54%;
  max-width: 434px;
  content: "";
  background: url("/brand/reports/transia-grain-banner.png") right center / auto 100% no-repeat;
  mask-image: linear-gradient(90deg, transparent 10%, rgb(0 0 0 / 0.025) 18%, rgb(0 0 0 / 0.10) 26%, rgb(0 0 0 / 0.30) 34%, rgb(0 0 0 / 0.60) 42%, rgb(0 0 0 / 0.86) 48%, black 56%);
}
.dashboard-hero > div {
  align-items: center;
  padding-right: clamp(280px, 30cqw, 400px);
}
.dashboard-hero h1 {
  font-size: clamp(24px, 2.2cqw, 28px);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.035em;
}
.dashboard-hero [aria-hidden='true']:has(> svg) { width: 32px; height: 32px; }
.dashboard-hero [aria-hidden='true'] > svg { width: 20px; height: 20px; }
.dashboard-hero p { font-size: 13px; line-height: 1.4; color: var(--color-slate-800); }
@media (max-width: 979px) {
  [data-mobile-workspace="dashboard"] > .dashboard-hero { min-height: 0; padding: 12px 16px; }
  .dashboard-hero::before { display: none; background-image: none; }
  .dashboard-hero > div { padding-right: 0; }
}
@container dashboard-hero (max-width: 719px) {
  .dashboard-hero > div { padding-right: 0; }
  .dashboard-hero::before { display: none; background-image: none; }
  .dashboard-hero [aria-hidden='true']:has(> svg) { width: 40px; height: 40px; }
  .dashboard-hero p { font-size: 15px; }
}
.dashboard-calculation-target { border-radius: 4px; cursor: help; }
.dashboard-calculation-target:focus-visible { outline: 2px solid var(--color-accent); outline-offset: 3px; }
.dashboard-calculation-content { display: grid; gap: 10px; font-size: 12px; line-height: 1.5; color: var(--color-slate-700, #334155); }
.dashboard-calculation-content > p { margin: 0; }
.dashboard-calculation-target .dashboard-hint-button { cursor: inherit; }
.fleet-summary dt { display: flex; align-items: center; gap: 5px; }
.fleet-summary > .dashboard-calculation-target { display: flex; flex-direction: column; justify-content: space-between; }
.dashboard-status-square { display: inline-block; flex: none; width: 7px; height: 7px; border-radius: 0; background: var(--color-slate-400, #94a3b8); }
.dashboard-status-square[data-tone="success"] { background: var(--color-success); }
.dashboard-status-square[data-tone="warning"] { background: var(--color-status-warning-ink); }
/* Key indicator strip: five cells; narrow layouts keep no empty cell (utilization full width, then 2 × 2). */
.dashboard-kpi-strip { container: dashboard-kpi-strip / inline-size; min-width: 0; }
.dashboard-kpi-grid { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); overflow: hidden; border: 1px solid var(--color-slate-200, #e2e8f0); background: #fff; }
.dashboard-kpi-grid > .dashboard-calculation-target { border-radius: 0; box-shadow: -1px 0 0 var(--color-slate-200, #e2e8f0), 0 -1px 0 var(--color-slate-200, #e2e8f0); }
.dashboard-kpi-cell { display: flex; min-width: 0; flex-direction: column; gap: 4px; padding: 9px 14px 8px; }
.dashboard-kpi-label { overflow: hidden; font-size: 11px; font-weight: 600; line-height: 1.3; color: var(--color-slate-700, #334155); text-overflow: ellipsis; white-space: nowrap; }
.dashboard-kpi-main { display: flex; align-items: flex-end; justify-content: space-between; gap: 8px; }
.dashboard-kpi-value { font-size: 25px; font-weight: 750; line-height: 1; letter-spacing: -0.02em; color: var(--color-slate-900, #0f172a); font-variant-numeric: tabular-nums; white-space: nowrap; }
.dashboard-kpi-spark { display: block; flex: none; width: 72px; height: 28px; }
.dashboard-kpi-spark rect { fill: var(--color-slate-400, #94a3b8); }
.dashboard-kpi-spark rect[data-selected] { fill: var(--color-slate-700, #334155); }
.dashboard-kpi-delta { min-height: 15px; font-size: 11px; line-height: 15px; white-space: nowrap; }
.dashboard-kpi-delta [data-tone], .dashboard-delta[data-tone] { font-weight: 700; }
[data-tone="good"]:is(.dashboard-kpi-delta span, .dashboard-delta) { color: var(--color-success); }
[data-tone="bad"]:is(.dashboard-kpi-delta span, .dashboard-delta) { color: var(--color-status-warning-ink); }
[data-tone="flat"]:is(.dashboard-kpi-delta span, .dashboard-delta) { color: var(--color-slate-600, #475569); }
.dashboard-kpi-compare { color: var(--color-slate-600, #475569); }
.dashboard-kpi-rows { display: grid; gap: 4px; margin: 0; }
.dashboard-kpi-rows > div { display: flex; justify-content: space-between; gap: 12px; }
.dashboard-kpi-rows dt { color: var(--color-slate-700, #334155); }
.dashboard-kpi-rows dd { margin: 0; font-weight: 700; white-space: nowrap; font-variant-numeric: tabular-nums; }
.dashboard-kpi-cell[aria-haspopup="dialog"] { cursor: pointer; }
.fleet-dialog:is(.dashboard-low-load-dialog, .dashboard-kpi-dialog) { width: min(980px, 100%); }
.fleet-dialog:is(.dashboard-low-load-dialog, .dashboard-kpi-dialog) > .fleet-day-metrics { max-width: none; }
.dashboard-kpi-dialog .dashboard-kpi-detail-table { min-width: 540px; table-layout: auto; }
.dashboard-kpi-dialog .dashboard-kpi-detail-table th:first-child { width: auto; }
.dashboard-kpi-dialog tfoot { font-weight: 700; }
.dashboard-low-load-tabs { display: flex; gap: 6px; margin: 10px 0; }
.dashboard-low-load-dialog .dashboard-low-load-table { min-width: 650px; table-layout: auto; }
.dashboard-low-load-dialog .dashboard-low-load-table th:first-child { width: auto; }
.dashboard-low-load-formula { display: grid; gap: 4px; padding: 10px 12px; border: 1px solid var(--color-slate-200); background: var(--color-slate-50); font-size: 12px; }
.dashboard-low-load-formula strong { font-size: 16px; font-variant-numeric: tabular-nums; }
.dashboard-low-load-dialog tfoot { font-weight: 700; }
.fleet-dialog.dashboard-low-load-dialog { display: flex; flex-direction: column; overflow: hidden; }
.dashboard-low-load-dialog > .fleet-card-header { flex-shrink: 0; padding-bottom: 10px; }
.dashboard-low-load-body { min-height: 0; overflow: auto; overscroll-behavior: contain; }
.dashboard-low-load-details { border: 1px solid var(--color-slate-200); margin-top: 10px; }
.dashboard-low-load-details > summary { padding: 8px 10px; cursor: pointer; font-size: 12px; font-weight: 650; }
.dashboard-low-load-details > summary:focus-visible { outline: 2px solid var(--color-accent); outline-offset: -2px; }
.dashboard-low-load-calculation { padding: 0 10px 10px; }
.dashboard-low-load-calculation > .fleet-day-metrics { margin: 10px 0; }
.dashboard-low-load-influence { display: grid; grid-template-columns: minmax(0, 1fr); gap: 12px; margin: 0; }
.dashboard-low-load-influence > section { min-width: 0; }
.dashboard-low-load-influence h3 { margin: 0; font-size: 13px; font-weight: 700; }
.dashboard-low-load-finding { padding: 10px 12px; border: 1px solid var(--color-slate-200); border-left: 3px solid var(--color-accent); background: var(--color-slate-50); }
.dashboard-low-load-finding p { margin: 5px 0 0; font-size: 12px; line-height: 1.5; }
.dashboard-low-load-sites-header { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 4px 12px; align-items: baseline; }
.dashboard-low-load-sites-header > span { font-size: 12px; white-space: nowrap; }
.dashboard-low-load-sites-scroll { max-height: 260px; overflow: auto; border: 1px solid var(--color-slate-200); border-radius: 4px; }
.dashboard-low-load-dialog .dashboard-low-load-sites-table { min-width: 600px; table-layout: auto; }
.dashboard-low-load-dialog .dashboard-low-load-sites-table th:first-child { width: 38%; }
.dashboard-low-load-sites-table th, .dashboard-low-load-sites-table td { padding: 7px 8px; }
.dashboard-low-load-sites-table thead th { position: sticky; top: 0; background: var(--color-slate-50); font-size: 10px; z-index: 1; }
@container dashboard-kpi-strip (max-width: 1060px) {
  .dashboard-kpi-main { flex-direction: column; align-items: stretch; }
  .dashboard-kpi-spark { width: 100%; }
}
@container dashboard-kpi-strip (max-width: 900px) {
  .dashboard-kpi-cell { padding: 8px 12px; }
  .dashboard-kpi-value { font-size: 22px; }
}
@container dashboard-kpi-strip (max-width: 760px) {
  .dashboard-kpi-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .dashboard-kpi-grid > :first-child { grid-column: 1 / -1; }
  .dashboard-kpi-grid > :first-child .dashboard-kpi-main { flex-direction: row; align-items: flex-end; }
  .dashboard-kpi-grid > :first-child .dashboard-kpi-spark { width: 96px; }
  .dashboard-kpi-value { font-size: 24px; }
}
.dashboard-page-status { margin: 8px 0; padding: 14px 16px; border: 1px solid var(--color-slate-200, #e2e8f0); border-radius: 4px; background: #fff; font-size: 13px; color: var(--color-slate-700, #334155); }
/* Main row: daily utilization next to « À surveiller ». */
.dashboard-main-row { display: grid; min-width: 0; gap: 12px; align-items: stretch; }
@media (min-width: 1280px) { .dashboard-main-row { grid-template-columns: minmax(0, 2fr) minmax(0, 1fr); } }
.dashboard-watch-count { font-weight: 700; }
.dashboard-watch-count[data-tone="warning"] { color: var(--color-status-warning-ink); }
.dashboard-watch-count[data-tone="ok"] { color: var(--color-success); }
.dashboard-watch-scope { flex: 0 1 auto; margin: 3px 0 0; font-size: 11px; color: var(--color-slate-600, #475569); text-align: right; }
.dashboard-watch-list { display: grid; margin: 6px 0 0; padding: 0; list-style: none; }
.dashboard-watch-item { display: grid; grid-template-columns: 10px minmax(0, 1fr); gap: 10px; padding: 6px 0; border-top: 1px solid #eef2f5; }
.dashboard-watch-item:first-child { border-top: 0; padding-top: 2px; }
.dashboard-watch-mark { width: 8px; height: 8px; margin-top: 5px; background: var(--color-slate-400, #94a3b8); }
.dashboard-watch-mark[data-tone="warning"] { background: var(--color-amber); }
.dashboard-watch-mark[data-tone="ok"] { background: var(--color-success); }
.dashboard-watch-title { margin: 0; font-size: 13px; font-weight: 700; line-height: 1.35; color: var(--color-slate-900, #0f172a); }
.dashboard-watch-detail { margin: 2px 0 0; font-size: 11px; line-height: 1.45; color: var(--color-slate-700, #334155); }
.dashboard-watch-link { display: inline-block; margin-top: 2px; padding: 0; border: 0; background: none; font: inherit; font-size: 11px; font-weight: 700; color: var(--color-accent); text-decoration: none; cursor: pointer; }
.dashboard-watch-link:hover { text-decoration: underline; }
.dashboard-watch-link:focus-visible { outline: 2px solid var(--color-accent); outline-offset: 2px; }
/* « Revenu et coût »: three figures over the revenue and cost bars of each dispatch. */
.dashboard-economics-scope { margin: 3px 0 0; font-size: 11px; color: var(--color-slate-600, #475569); }
.dashboard-economics-figures { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); margin: 0; overflow: hidden; border: 1px solid var(--color-slate-200, #e2e8f0); border-radius: 4px; }
.dashboard-economics-figures > .dashboard-calculation-target { border-radius: 0; box-shadow: -1px 0 0 var(--color-slate-200, #e2e8f0); }
.dashboard-economics-figure { display: flex; min-width: 0; flex-direction: column; gap: 4px; padding: 8px 12px 7px; }
.dashboard-economics-value { font-size: 21px; font-weight: 750; line-height: 1; letter-spacing: -0.02em; color: var(--color-slate-900, #0f172a); font-variant-numeric: tabular-nums; white-space: nowrap; }
.dashboard-economics-value small { font-size: 13px; font-weight: 700; letter-spacing: 0; color: var(--color-slate-700, #334155); }
.dashboard-economics-figure[data-sign="negative"] .dashboard-economics-value { color: var(--color-status-warning-ink); }
.dashboard-economics-partial { margin: 0; font-size: 11px; line-height: 1.45; color: var(--color-status-warning-ink); }
.dashboard-economics-partial .dashboard-watch-link { margin-top: 0; }
.dashboard-economics-empty { margin: 0; font-size: 12px; color: var(--color-slate-600, #475569); }
.economics-bar-revenue { fill: var(--color-accent); }
.economics-bar-cost { fill: #6b7280; }
.economics-swatch-revenue { background: var(--color-accent); }
.economics-swatch-cost { background: #6b7280; }
.dashboard-chart-canvas g[data-context] :is(rect, circle), .dashboard-chart-line[data-context] { opacity: .55; }
.dashboard-chart-average { stroke: #64748b; stroke-width: 1.25; stroke-dasharray: 4 4; }
.dashboard-chart-point { fill: #fff; stroke: var(--color-accent); stroke-width: 2; }
/* Three detail lists: label with its gauge, value, change. */
.dashboard-metric-lists { display: grid; min-width: 0; gap: 12px; align-items: start; }
@media (min-width: 1024px) { .dashboard-metric-lists { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
.dashboard-metric-list .dashboard-card-header p { margin: 3px 0 0; font-size: 11px; color: var(--color-slate-600, #475569); }
.dashboard-metric-rows { margin-top: 4px; }
.dashboard-metric-rows > .dashboard-metric-row { display: grid; grid-template-columns: minmax(0, 1fr) auto minmax(64px, auto); align-items: center; gap: 10px; padding: 5px 0; border-top: 1px solid #eef2f5; border-radius: 0; }
.dashboard-metric-rows > .dashboard-metric-row:first-child { border-top: 0; }
.dashboard-metric-label { min-width: 0; font-size: 12px; line-height: 1.35; color: #334155; }
.dashboard-metric-gauge { display: block; height: 4px; margin-top: 5px; overflow: hidden; border-radius: 2px; background: #eef2f5; }
.dashboard-metric-gauge > span { display: block; height: 100%; border-radius: 2px; background: var(--color-accent); }
.dashboard-metric-value { font-size: 15px; font-weight: 750; color: var(--color-slate-900, #0f172a); font-variant-numeric: tabular-nums; text-align: right; white-space: nowrap; }
.dashboard-metric-delta { font-size: 11px; font-weight: 700; text-align: right; white-space: nowrap; color: var(--color-slate-600, #475569); }
.dashboard-metric-delta[data-tone="good"] { color: var(--color-success); }
.dashboard-metric-delta[data-tone="bad"] { color: var(--color-status-warning-ink); }
/* « Par jour de semaine »: the five weekdays side by side. */
.dashboard-weekday-grid { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 8px; margin-top: 3px; }
.dashboard-weekday { display: grid; min-width: 0; gap: 1px; border-radius: 4px; }
.dashboard-weekday .dashboard-metric-label { font-size: 11px; }
.dashboard-weekday .dashboard-metric-value { text-align: left; }
.dashboard-weekday .dashboard-metric-gauge { margin-top: 3px; }
/* « Revenu et coût »: figures beside the chart when the card is wide, above it when it shares a row. */
.dashboard-economics { container: dashboard-economics / inline-size; }
.dashboard-economics-body { display: grid; min-width: 0; gap: 6px 16px; margin-top: 8px; }
.dashboard-economics-summary { display: grid; min-width: 0; align-content: start; gap: 6px; }
@container dashboard-economics (min-width: 760px) {
  .dashboard-economics-body { grid-template-columns: minmax(230px, 1fr) minmax(0, 3fr); align-items: start; }
  .dashboard-economics-body .dashboard-economics-figures { grid-template-columns: minmax(0, 1fr); }
  .dashboard-economics-body .dashboard-economics-figures > .dashboard-calculation-target { box-shadow: 0 -1px 0 var(--color-slate-200, #e2e8f0); }
  .dashboard-economics-body .dashboard-economics-figure { flex-flow: row wrap; align-items: baseline; gap: 2px 8px; padding: 6px 10px; }
  .dashboard-economics-body .dashboard-economics-figure > .dashboard-kpi-label { flex-basis: 100%; }
}
@container dashboard-economics (max-width: 759px) {
  .dashboard-economics-figure { gap: 1px; padding: 5px 8px; }
  .dashboard-economics-value { font-size: 19px; }
  .dashboard-economics-figure .dashboard-kpi-compare { display: none; }
}
@container dashboard-economics (max-width: 339px) {
  .dashboard-economics-figures { grid-template-columns: minmax(0, 1fr); }
  .dashboard-economics-figures > .dashboard-calculation-target { box-shadow: 0 -1px 0 var(--color-slate-200, #e2e8f0); }
}
/* « Vue d’ensemble »: revenue, tonnage and peak fill side by side on a wide screen, their charts at the bottom of
   the cards so the three date rows line up. */
.dashboard-overview-row { display: grid; min-width: 0; gap: 12px; align-items: stretch; }
@media (min-width: 1280px) {
  .dashboard-overview-row { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .dashboard-overview-row > .dashboard-card { display: flex; flex-direction: column; }
  .dashboard-overview-row > .dashboard-card > :is(.dashboard-card-body, .dashboard-economics-body) { flex: 1 0 auto; align-content: space-between; }
  .dashboard-overview-row > .dashboard-trend-card > .dashboard-card-body { display: flex; flex-direction: column; justify-content: flex-end; }
}
/* Body: overview cards; the detail lists in a right column when the page is wide, else in the « Détail » view.
   In the column, the last list reaches the bottom of the charts. */
.dashboard-page { container: dashboard-page / inline-size; }
.dashboard-body { display: grid; min-width: 0; gap: 0.25rem 12px; }
.dashboard-view-tabs { display: contents; }
.dashboard-body[data-view="overview"] > .dashboard-metric-lists { display: none; }
.dashboard-body[data-view="detail"] > :is(.dashboard-main-row, .dashboard-overview-row) { display: none; }
@container dashboard-page (min-width: 1600px) {
  .dashboard-view-tabs { display: none; }
  .dashboard-body { grid-template-columns: minmax(0, 1fr) 360px; align-items: start; }
  .dashboard-body > * { grid-column: 1; }
  .dashboard-body[data-view] > :is(.dashboard-main-row, .dashboard-overview-row) { display: grid; }
  .dashboard-body[data-view] > .dashboard-metric-lists { display: grid; grid-column: 2; grid-row: 1 / span 3; grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(3, auto) minmax(0, 1fr); align-self: stretch; }
}
/* Page density for a 1080p screen; the email reports keep their own spacing. */
.dashboard-page .dashboard-card { padding: 10px 12px; }
.dashboard-page .dashboard-card-header p { margin-top: 2px; }
.dashboard-page .dashboard-card-body { margin-top: 6px; }
